var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link inline-flex relative text-gray-500 hover:text-white text-sm md:text-base",attrs:{"href":"#"},on:{"click":_vm.changeLocale}},[_vm._v("\n  "+_vm._s(_vm.$t('switchLink'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }